import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Col,
  Label,
  Progress,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import InputText from "components/Common/InputText";
import { showToast } from "components/Common";
import MapCategoryService from "services/MasterCategory";
import Select from "react-select";
import { UpdateMapCategorySurveyManual } from "../../helpers/app-backend/categorysurveybackend_helpers";

const Schema = Yup.object().shape({
  categoryIDSurvey: Yup.number().required("Không được bỏ trống"),
});

const Index = ({
  isOpen,
  onClose,
  data,
  getDataTable,
  paging,
  dataFilter,
}) => {
  const [loading, setIsLoading] = useState(false);
  const [selectMasterCategory, setSelectMasterCategory] = useState([]);
  const [dataMasterCategory, setDataMasterCategory] = useState([]);
  const getdataMasterCategory = async () => {
    const res =
      await MapCategoryService.GetLsMasterCategoryService({
        search: "",
      });
    res.unshift({ value: null, label: "Giá trị rỗng(NULL)" });
    setDataMasterCategory(res);
  };

  const formik = useFormik({
    initialValues: {
      categoryIDSurvey: data?.categoryIDSurvey || "",
      categoryNameSurvey: data?.categoryNameSurvey || "",
      mapMasterCategoryID: data?.mapMasterCategoryID || "",
    },
    validationSchema: Schema,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: values => {
      updateCategory(values);
    },
  });

  const getRequestParams = (_params = {}, _requestBody = {}) => {
    const reqParams = {
      params: {
        ..._params,
      },
      requestBody: {
        ..._requestBody,
      },
    };
    return reqParams;
  };

  const updateCategory = async (_requestBody = {}, _params = {}) => {
    const { params, requestBody } = getRequestParams(_params, _requestBody);

    const res = await UpdateMapCategorySurveyManual(requestBody);
    if (res.error) {
      showToast(`${res.error.title}: ${res.error.description}`, 3);
    } else {
      showToast("Cập nhật thành công", 1);
      getDataTable(dataFilter, paging);
      onClose();
    }
  };
  useEffect(() => {
    if (dataMasterCategory.length > 0) return;
    getdataMasterCategory();
  }, []);

  useEffect(() => {
    if (!dataMasterCategory || !dataMasterCategory.length) return;
    let selectMasterCategory = dataMasterCategory.find(
      x => x.value == data?.mapMasterCategoryID
    );
    if (selectMasterCategory) {
      setSelectMasterCategory(selectMasterCategory);
    } else {
      setSelectMasterCategory(dataMasterCategory[0]);
    }
  }, [dataMasterCategory]);

  return (
    <Modal isOpen={isOpen} style={{ maxWidth: "650px", width: "100%" }}>
      <ModalHeader>
        CẬP NHẬT MapMasterCategoryID
      </ModalHeader>
      <ModalBody>
        <Row style={{ display: "flex", justifyContent: "center" }}>
          <Col md={6} lg={8}>
            <InputText
              label="CategoryIDSurvey"
              name="CategoryIDSurvey"
              onChange={e => {
                formik.handleChange(e);
                formik.setErrors(null);
              }}
              value={formik.values.categoryIDSurvey}
              errors={formik.errors}
              disabled={true}
              isRequired
            />
          </Col>
        </Row>
        <Row style={{ display: "flex", justifyContent: "center" }}>
          <Col md={6} lg={8}>
            <InputText
              label="CategoryNameSurvey"
              name="CategoryNameSurvey"
              onChange={e => {
                formik.handleChange(e);
                formik.setErrors(null);
              }}
              value={formik.values.categoryNameSurvey}
              errors={formik.errors}
              disabled={true}
            />
          </Col>
        </Row>
        <Row style={{ display: "flex", justifyContent: "center" }}>
          <Col md={6} lg={8}>
            <Label className="mb-0 text-truncate" style={{ minWidth: "98px" }}>
              MapMasterCategoryID
            </Label>
            <div style={{ display: "flex" }}>
              <Select
                options={dataMasterCategory || []}
                placeholder=""
                value={selectMasterCategory}
                onChange={val => {
                  formik.setFieldValue("mapMasterCategoryID", val.value);
                  setSelectMasterCategory(val);
                }}
                isDisabled={loading}
                styles={{
                  control: base => ({
                    ...base,
                    border: `1px solid  "rgb(206, 212, 218)"`,
                    maxWidth: "400px",
                    width: "400px",
                  }),
                }}
              />
              {selectMasterCategory && (
                <Button
                  onClick={() => {
                    formik.setFieldValue("mapMasterCategoryID", null);
                    setSelectMasterCategory({
                      value: null,
                      label: "Giá trị rỗng(NULL)",
                    });
                  }}
                  className="clear-button"
                  color="link"
                >
                  <i className="mdi mdi-close"></i>
                </Button>
              )}
            </div>
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter style={{ display: "flex", justifyContent: "center" }}>
        {loading && (
          <Row
            style={{ width: "80%", justifyContent: "center", display: "flex" }}
          >
            <Label>
              Quá trình xử lí này có thể mất vài phút, vui lòng chờ đến khi kết
              thúc...
            </Label>
            <div className="mt-1">
              <Progress color="primary" animated value="100" />
            </div>
          </Row>
        )}
        <div>
          <Button
            disabled={loading}
            color="primary"
            onClick={formik.handleSubmit}
          >
            Đồng ý
          </Button>{" "}
          <Button color="danger" onClick={onClose}>
            Đóng
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  );
};

export default Index;
